import { useState, useEffect } from 'react'
import globalConfig from 'i18n-for-browser'
import '../../config/i18n'

export default function useMultilineTextUrl (localizationKey) {
    const [url, setUrl] = useState('')
    const currentLocale = globalConfig.getLocale()

    useEffect(() => {
        async function __getUrl () {
            // get the text file url dynamically
            const module = await import(`../../locales/${currentLocale}/${localizationKey}.txt`)
            if (url !== module.default) {
                // this should trigger re-render
                setUrl(module.default)
            }
        }
        __getUrl()
    }, [url, currentLocale, localizationKey])

    return url
}
